import {
  Divider,
  Grid,
  Typography,
  makeStyles,
  Box,
  Avatar,
  useTheme,
} from "@material-ui/core";
import DeleteEditActionButtons from "../../components/DeleteEditActionButtons/DeleteEditActionButtons";
import React from "react";
import StarRateRoundedIcon from "@material-ui/icons/StarRateRounded";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDivider-root": {
      height: 1,
      width: "100%",
      marginTop: theme.spacing(1),
    },
  },
  small: {
    width: "25px",
    height: "25px",
  },
  star: {
    color: theme.palette.warning.main,
  },
}));

const CompanyContacts = ({ contacts, onContactsRemove }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <React.Fragment>
      <Box className={classes.root}>
        <Grid spacing={1} container>
          <Grid item xs={4}>
            <Typography variant="subtitle1" color="textSecondary">
              Contact Name
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              Phone/Mobile
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1" color="textSecondary">
              email
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              align="right"
              style={{ paddingRight: theme.spacing(2) }}
            >
              Actions
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        {contacts.map((contact) => (
          <SingleContact
            contact={contact}
            key={contact.id}
            onRemove={() => onContactsRemove(contact.id)}
          />
        ))}
      </Box>
    </React.Fragment>
  );
};
export default CompanyContacts;

const SingleContact = ({ contact, onRemove }) => {
  const classes = useStyles();
  const {
    id,
    contact_first_name,
    contact_last_name,
    contact_email,
    contact_mobile,
    is_primary,
  } = contact;
  return (
    <Grid container spacing={2} justify="flex-start" alignItems="center">
      <Grid item xs={1}>
        <Avatar style={{ width: 25, height: 25 }} />
      </Grid>
      <Grid item xs={3}>
        <Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
          {is_primary && <StarRateRoundedIcon className={classes.star} />}
          <Typography
            variant="body1"
            color="textSecondary"
            style={is_primary ? { marginLeft: 4 } : {}}
          >
            {`${contact_first_name} ${contact_last_name}`}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="body1" color="textSecondary">
          {contact_mobile}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="body1" color="textSecondary">
          {contact_email}
        </Typography>
      </Grid>
      <Grid item xs={2} style={{ display: "flex", justifyContent: "flex-end" }}>
        <Box maxWidth={80}>
          <DeleteEditActionButtons onRemove={() => onRemove(id)} />
        </Box>
      </Grid>
    </Grid>
  );
};
